export const bidOfferStatusValueGetter = (params: any) => {
  return params.data.status;
};
